<template>
  <a-form layout="vertical">
    <a-form-item v-if="!isChangePassword">
      <template #label>
        <span class="required">*</span>
        <span class="label"> Correo</span>
      </template>
      <a-input disabled :value="`${getEmail}`" />
    </a-form-item>
    <a-form-item>
      <template #label>
        <span class="required">*</span>
        <span class="label"> Nueva contraseña </span>
      </template>
      <a-input-password
        v-model:value="password"
        @input="handleChangeNewPassword"
        placeholder="Escribir contraseña"
      />
      <template #help>
        <div class="help">
          <div v-for="help of helps" :key="help.text" class="help__item">
            <CheckCircleOutlined
              v-if="help.active"
              class="help__icon"
              :class="getClass(help.active)"
            />
            <CloseCircleOutlined v-else class="help__icon" :class="getClass(help.active)" />
            <span>{{ help.text }}</span>
          </div>
        </div>
      </template>
    </a-form-item>

    <a-form-item :validate-status="getPasswordValidationStatus">
      <template #label>
        <span class="required">*</span>
        <span class="label"> Confirmar contraseña </span>
      </template>
      <a-input-password v-model:value="confirmation" placeholder="Confirmar contraseña" />
      <template #help>
        <span v-if="!thereIsMatch"> La contraseña no es la misma</span>
      </template>
    </a-form-item>
  </a-form>
</template>

<script>
import { useStore } from "vuex";
import { defineComponent, ref, computed } from "vue";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons-vue";
export default defineComponent({
  components: {
    CheckCircleOutlined,
    CloseCircleOutlined,
  },
  name: "RegisterPassword",
  props: {
    value: {
      required: true,
      type: String,
    },
    ckeckterms: {
      required: true,
      type: Boolean,
    },
    ckecksubscribe: {
      required: true,
      type: Boolean,
    },
    isChangePassword: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useStore();
    const email = computed(() => store.getters["getNewUserInvite"]);
    const password = ref("");
    const confirmation = ref("");
    const thereIsMatch = computed(() => {
      return password.value === confirmation.value;
    });

    return {
      email,
      store,
      password,
      confirmation,
      thereIsMatch,
    };
  },
  data() {
    return {
      initial: true,
      helps: [
        {
          active: false,
          text: "Al menos 8 caracteres de longitud",
          rule: (value) => value.length >= 8,
        },
        {
          active: false,
          text: "Usar mínimo un caracter en mayúscula",
          rule: (value) => /[A-Z]/.test(value),
        },
        {
          active: false,
          text: "Usar mínimo un caracter en minúscula",
          rule: (value) => /[a-z]/.test(value),
        },
        {
          active: false,
          text: "Un número, símbolo o espacio en blanco",
          rule: (value) => /[<\d\-\\[\]{|}()/¡!¿?'"@#$%&*+,.:;^~_=`> ]/.test(value),
        },
      ],
    };
  },
  computed: {
    isPasswordStrong() {
      const actives = this.helps.map((help) => help.active);
      return actives.reduce((previous, current) => previous && current, true);
    },
    formIsReady() {
      return this.isPasswordStrong && this.thereIsMatch && !!this.confirmation;
    },
    getPasswordValidationStatus() {
      return !this.thereIsMatch ? "error" : "";
    },
    getEmail() {
      return this.$store.getters["getNewUserInviteEmail"];
    },
  },

  watch: {
    password(value) {
      this.helps.forEach((help) => {
        help.active = help.rule(value);
      });
    },
    formIsReady(value) {
      if (value) this.$emit("setPassword", this.password);
      else this.$emit("setPassword", "");
    },
  },
  methods: {
    getType(active) {
      return active ? "check-circle" : "close-circle";
    },
    getClass(active) {
      const initial = this.initial ? "help__icon--initial" : "help__icon--error";
      return active ? "help__icon--success" : initial;
    },
    handleChangeNewPassword() {
      this.initial = false;
    },
  },
});
</script>

<style lang="sass" scoped>
.help
  margin: 0.75rem 0

  &__item
    padding: 0.325rem 0

  &__icon
    margin-right: 0.5rem

    &--initial
      color: $gray-4

    &--success
      color: #52C41A

    &--error
      color: $red-6

.item__checkbox
  margin-top: 10px

.item__information
  margin-top: -10px

.required
  color: $red-7
  margin-right: 2px
</style>
